export default "__VITE_ASSET__7144588a__"